import { Route, Routes } from "react-router-dom";

import R1DataUpload from "./R1DataUpload/main";
import R1Documents from "./R1Documents/main";
import R1PeFunds from "./R1PeFunds/main";
import R1Issuers from "./R1Issuers/main";
import R1Positions from "./R1Positions/main";
import R1CapitalAccount from "./R1CapitalAccount/main";
import R1Mastersheet from "./R1Mastersheet/main";
import R1Analytics from "./R1Analytics/main";
import R1LevelAnalytics from "./R1LevelAnalytics/main";
import R1PositionsIssuers from "./R1PositionsIssuers/main";
import R1ManagementCompanies from "./R1ManagementCompanies/main";
import R1FundsPortfolio from "./R1FundsPortfolio/main";
import R1EmailLogs from "./R1EmailLogs/main";
import R1PositionsIssuersReconciliation from "./R1PositionsIssuersReconciliation/main";
import R1RawData from "./R1RawData/main";

export default function R1Routes() {
  return (
    <Routes>
      <Route path="r1_data_upload/*" element={<R1DataUpload />} />
      <Route path="r1_documents/*" element={<R1Documents />} />
      <Route path="r1_pe_funds/*" element={<R1PeFunds />} />
      <Route path="r1_issuers/*" element={<R1Issuers />} />
      <Route path="r1_positions/*" element={<R1Positions />} />
      <Route path="r1_capital_account/*" element={<R1CapitalAccount />} />
      <Route path="r1_mastersheet/*" element={<R1Mastersheet />} />
      <Route path="r1_analytics/*" element={<R1Analytics />} />
      <Route path="r1_level_analytics/*" element={<R1LevelAnalytics />} />
      <Route path="r1_positions_issuers/*" element={<R1PositionsIssuers />} />
      <Route
        path="r1_management_companies/*"
        element={<R1ManagementCompanies />}
      />
      <Route path="r1_funds_portfolio/*" element={<R1FundsPortfolio />} />
      <Route path="r1_email_logs/*" element={<R1EmailLogs />} />
      <Route
        path="r1_reconciliation/*"
        element={<R1PositionsIssuersReconciliation />}
      />
      <Route
        path="r1_positions_issuers_reconciliation/*"
        element={<R1PositionsIssuersReconciliation />}
      />
      <Route path="r1_raw_data/*" element={<R1RawData />} />
    </Routes>
  );
}
